import React, { useEffect, useState, useRef } from "react";
import { useReduxStore } from "../../hooks/useReduxStore";
import {
  GetItemDetail,
  GetSimilarItems,
  ToggleWishlistItemAction,
  ViewItemAction,
} from "../../store/Actions/action";
import { updateItem } from "../../store/Reducers/itemReducer";
import { updateHome } from "../../store/Reducers/homeReducer";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../store/Reducers/authReducer";
import { useMemo } from "react";
import useSetWidth from "../../hooks/useSetWidth";
import { useSearchParams } from "react-router-dom";
const useDetail = () => {
  const playerRef = useRef(null);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const { dispatch, getState } = useReduxStore();
  const { itemDetail, similarItems, similarItemsLoading, itemLoading } =
    getState("Item");
  const { loading, token, userData } = getState("AUTH");
  const { width } = getState("Home");
  const [open, setOpen] = useState(false);
  const [featuredVideoModal, setFeaturedVideoModal] = useState(false);
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    actionType: "general",
    title: "",
    message: "",
  });
  let data = window?.history?.state?.usr || itemDetail || {};
  const similarItemsData = useMemo(() => {
    return similarItems.filter((item) => item?.id !== itemDetail.id);
  }, [similarItems]);
  const handleOpen = () => setOpen(!open);

  const handleLoginModal = (config) => {
    if (typeof config === "string") {
      setModalConfig({
        isOpen: true,
        actionType: config,
        title: "",
        message: "",
      });
    } else if (config && typeof config === "object") {
      setModalConfig({
        isOpen: config.isOpen !== undefined ? config.isOpen : true,
        actionType: config.actionType || config.action || "general",
        title: config.title || "",
        message: config.message || "",
      });
    } else {
      setModalConfig((prev) => ({
        ...prev,
        isOpen: !prev.isOpen,
      }));
    }
  };

  const currentDetailPath = `/Detail?id=${id || data?.id || 1}`;

  const onLoginClick = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
    navigate("/Login", { state: { route: currentDetailPath } });
  };

  const onSignupClick = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
    navigate("/Signup", { state: { route: currentDetailPath } });
  };

  const toggleFaturedVideoModal = () => setFeaturedVideoModal(!featuredVideoModal);
  const getItemDetail = () => {
    dispatch(
      GetItemDetail({
        id: id || data?.id,
        token,
        user_id: userData?.id,
      })
    );
  };
  const togglePlayerOpen = () => {
    setIsPlayerOpen((prev) => !prev);
    const audioElement = playerRef.current?.audio?.current;
    if (audioElement) {
      if (audioElement.paused) {
        audioElement.play().catch(() => {});
      } else {
        audioElement.pause();
      }
    }
  };
  const viewItem = () => {
    dispatch(ViewItemAction({ id: data?.id || 1 }));
  };
  const getSimilarItems = (id) => {
    dispatch(GetSimilarItems({ id }));
  };
  const onClickBuy = (customItem) => {
    const target = customItem || itemDetail || data;
    if (token) {
      dispatch(updateItem({ itemDetail: target }));
      dispatch(updateHome({ selectedPackage: null }));
      navigate("/Checkout", {
        state: {
          item: target,
          isSubscription: false,
        },
      });
    } else {
      handleLoginModal({
        actionType: "buy",
        title: "Sign In to Purchase",
        message: target?.title
          ? `Please sign in to purchase or rent "${target.title}".`
          : "Please sign in to purchase or rent this item securely.",
      });
    }
  };
  const onUnMount = () => {
    dispatch(updateItem({ itemDetail: {} }));
  };

  const onWishClick = () => {
    token
      ? dispatch(
          ToggleWishlistItemAction({
            id: data?.id || 1,
            itemDetail: {
              ...itemDetail,
              is_favourite: !itemDetail.is_favourite,
            },
          })
        )
      : handleLoginModal({
          actionType: "wishlist",
          title: "Save to Wishlist",
          message: "Please sign in to add your favorite titles to your personal wishlist.",
        });
  };
  useEffect(() => {
    getItemDetail();
    viewItem();
  }, []);
  useEffect(() => {
    itemDetail?.category && getSimilarItems(itemDetail?.category[0]?.id);
  }, [itemDetail?.id]);
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);
  useEffect(() => {
    const typeParam = searchParams.get("type");
    if (typeParam === "playlist" || data?.type === "playlist") {
      navigate(`/Playlist?id=${id || data?.id || 1}`, { replace: true });
    }
  }, [id, searchParams, data, navigate]);
  // useEffect(() => {
  //   return () => {
  //     onUnMount();
  //   };
  // }, []);

  return {
    itemDetail,
    similarItems,
    similarItemsData,
    similarItemsLoading,
    data,
    open,
    itemLoading,
    playerRef,
    featuredVideoModal,
    toggleFaturedVideoModal,
    handleOpen,
    loading,
    token,
    userData,
    onClickBuy,
    onWishClick,
    loginModal: modalConfig.isOpen,
    modalConfig,
    handleLoginModal,
    onLoginClick,
    onSignupClick,
    isPlayerOpen,
    setIsPlayerOpen,
    togglePlayerOpen,
    width,
  };
};

export default useDetail;
